<template>
  <div>
    <spotlight-product-list :product-list="productList">
      <template v-slot="slotProps">
        <spotlight-product-card
          :title="$t(`message.spotlightV2.categories.features.${slotProps.product.internalName}.title`)"
          :text="
            $t(
              `message.spotlightV2.categories.features.${slotProps.product.internalName}.text`,
              slotProps.product.payload
            )
          "
          :path="`features/${slotProps.product.internalName}`"
          @click.native="trackClick($event, `features.${slotProps.product.internalName}`)"
        >
          <template v-slot:product-icon v-if="productList.category === enums.SpotlightConstants.categories.FEATURES">
            <font-awesome-icon
              class="text-primary"
              :icon="['far', `${featuresProductDataMap[slotProps.product.internalName].icon}`]"
              :style="{ marginLeft: '5px' }"
            ></font-awesome-icon>
          </template>
        </spotlight-product-card>
      </template>
    </spotlight-product-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';

const SpotlightProductList = () => import('@/modules/spotlight/components/SpotlightProductList.vue');
const SpotlightProductCard = () => import('@/modules/spotlight/components/SpotlightProductCard.vue');

export default {
  name: 'Features',
  components: {
    SpotlightProductList,
    SpotlightProductCard,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('spotlight', ['getSpotlightCategories']),
    productList() {
      return (
        this.getSpotlightCategories.find(
          payload => payload.category === this.enums.SpotlightConstants.categories.FEATURES
        )?.spotlights || []
      );
    },
    featuresProductDataMap() {
      return {
        [this.enums.SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']]: {
          icon: 'volume',
        },
      };
    },
  },
  methods: {
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.${spotlight}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
